import { Injectable } from '@angular/core';
import { CepRuleFilters } from "../model/filters/cep-rule-filters";
import { Observable } from "rxjs";
import { HttpUtils } from "../shared/http.utils";
import { HttpClient } from "@angular/common/http";
import { CepRulePersistRequest } from "../model/requests/cep-rule-persist-request";
import { CepRule } from "../model/cep-rule";

@Injectable({
  providedIn: 'root'
})
export class CepRulesService {

  private readonly cepRulesURL: string;

  constructor(private http: HttpClient) {
    this.cepRulesURL = "/catalog/cep_rules";
  }

  public getCepRules(offset?: number, limit?: number, filters?: CepRuleFilters): Observable<any>{
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    let body = (filters != null) ? filters : new CepRuleFilters();
    return this.http.post<any>(this.cepRulesURL, body, options);
  }

  public createCepRule(persistData: CepRulePersistRequest) {
    let url = `${this.cepRulesURL}/create`;
    return this.http.post<any>(url, persistData);
  }

  public editCepRule(persistData: CepRulePersistRequest) {
    let url = `${this.cepRulesURL}/edit`;
    return this.http.post<any>(url, persistData);
  }

  public deleteCepRules(identifiers: {tenantUuid: string, organizationUuid: string, name: string}[]) {
    let url = `${this.cepRulesURL}/delete`;
    return this.http.post<any>(url, identifiers, {observe: 'response'});
  }

  public updateRuleState(cepRules: CepRule[], newRuleState: string) {
    let options = HttpUtils.buildOptions({newRuleState: newRuleState});
    let url = `${this.cepRulesURL}/update_state`;
    return this.http.post<any>(url, cepRules, options);
  }

}
